import { NZ_GREAT_WALK_CANCELLATION_LIST } from '../components/Blogs/nzGreatWalksCancellations.js';

/**
 * Coerce a value that may be an ObjectId string, a populated Mongoose subdoc,
 * or a plain object with `_id` into a string id. Returns `''` when we can't
 * derive one.
 */
function idOf(value) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') return String(value._id ?? value);
  return String(value);
}

/**
 * Detect whether a `tripResults` track is one of the three Fiordland Great
 * Walks (Milford / Routeburn / Kepler) with per-hut cancellation stats.
 *
 * Matches by intersecting the track's child outing ids (`tripOptions[].childId`)
 * with each walk's known hut `outingId`s. Robust to track/hut renames and to
 * whether `childId` is a raw string or a populated subdoc.
 *
 * @param {{ tripOptions?: Array<{ childId?: unknown }> } | null | undefined} track
 * @returns {typeof NZ_GREAT_WALK_CANCELLATION_LIST[number] | null}
 */
export function nzGreatWalkForTrack(track) {
  if (!track?.tripOptions?.length) return null;
  const trackChildIds = new Set(
    track.tripOptions.map((opt) => idOf(opt?.childId)).filter(Boolean)
  );
  if (!trackChildIds.size) return null;

  for (const walk of NZ_GREAT_WALK_CANCELLATION_LIST) {
    const overlap = walk.huts.some((hut) => trackChildIds.has(String(hut.outingId)));
    if (overlap) return walk;
  }
  return null;
}
